import { httpsCallable } from 'firebase/functions';

import { functions } from '../firebase';
import { buildPlacementAttemptSubmission } from './placementAttempt';

const createPublicPlacementLeadCallable = httpsCallable(functions, 'createPublicPlacementLead');
const completePublicPlacementLeadCallable = httpsCallable(functions, 'completePublicPlacementLead');
const requestPublicPlacementEmailVerificationCallable = httpsCallable(functions, 'requestPublicPlacementEmailVerification');
const saveAuthenticatedPlacementTestAttemptCallable = httpsCallable(functions, 'saveAuthenticatedPlacementTestAttempt');

export async function requestPublicPlacementEmailVerification({ name, email, language }) {
  const result = await requestPublicPlacementEmailVerificationCallable({
    name,
    email,
    language,
  });

  const verificationId = result?.data?.verificationId;
  if (!verificationId || typeof verificationId !== 'string') {
    throw new Error('Email verification did not return an id.');
  }

  return { verificationId };
}

export async function createPublicPlacementLead({ name, email, language, consentToEmail, verificationCode }) {
  const result = await createPublicPlacementLeadCallable({
    name,
    email,
    language,
    consentToEmail: Boolean(consentToEmail),
    verificationCode,
  });

  const leadId = result?.data?.leadId;
  if (!leadId || typeof leadId !== 'string') {
    throw new Error('Lead creation did not return an id.');
  }
  const attemptId = result?.data?.attemptId;

  return { leadId, attemptId };
}

export async function completePublicPlacementLead({ leadId, attemptId, language, result }) {
  const response = await completePublicPlacementLeadCallable({
    leadId,
    attemptId,
    language,
    result,
  });

  return response?.data || { success: true };
}

export async function saveAuthenticatedPlacementTestAttempt({ language, result }) {
  const response = await saveAuthenticatedPlacementTestAttemptCallable({
    language,
    result: buildPlacementAttemptSubmission(result),
  });

  return response?.data || { success: true, attemptId: result?.attemptId };
}
